/**
 * Disable auto-opening the cart drawer on add-to-cart (explicit user
 * instruction: "the busket should when click on it not automatically by
 * adding produkt inside it").
 *
 * Root cause (confirmed live, not the `auto_open_cart_drawer` theme
 * setting — that one is already off and gates a separate, narrower
 * mechanism in assets/cart-drawer.js): Horizon's own native
 * assets/standard-actions-override.js configures Shopify.actions.openCart
 * to unconditionally call drawer.open() every time it's invoked, and
 * Shopify's own add-to-cart flow calls Shopify.actions.openCart() after
 * every successful add regardless of that theme setting.
 *
 * Per this project's own convention (never edit Horizon's own files
 * directly — Horizon overwrites them on update), this is a small
 * additive override instead: it re-configures openCart to a no-op,
 * loaded right after standard-actions-override.js in
 * snippets/scripts.liquid so it wins (module scripts execute in
 * document order).
 *
 * Left completely untouched by this file, both intentionally:
 * - Shopify.actions.updateCart (cart badge/total live update) — a
 *   separate action, still configured by standard-actions-override.js.
 * - The header cart icon's own manual `on:click="#cart-drawer/toggle"`
 *   — a different action-resolver pathway entirely (Component's own
 *   on:click framework, not Shopify.actions), so clicking the actual
 *   cart icon still opens the drawer normally.
 */
function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.openCart.configure({
    handler() {
      // Intentionally does nothing — don't open the drawer, don't
      // redirect to /cart either. Adding a product to the cart should
      // be silent; the customer opens the cart drawer themselves via
      // the header cart icon when they want to see it.
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
